import React from 'react';

import IconBtn from '../../modules/icon-btn/icon-btn';
import NoticeBig from '../../modules/notice-big/notice-big';
import TableFooterWrapper from '../../modules/table-footer-wrapper/table-footer-wrapper';
import TableWrapper from '../../modules/table-wrapper/table-wrapper';
import { ORDER_STATUS } from '../../types';
import { getOrderStatusBadge } from '../../utils/getStatusBadge';

import ErpIcon from './icons/erp-icon.svg';
import OrderDetailedHeader from './order-detailed-header/order-detailed-header';

interface OrderDetailedEmptyProps {
  status: ORDER_STATUS;
  onClose: () => void;
  inn: string;
  date: string;
  time: string;
  refId: string;
  name: string;
}

const OrderDetailedEmpty: React.FC<OrderDetailedEmptyProps> = ({
  status,
  onClose,
  inn,
  date,
  time,
  refId,
  name,
}) => (
  <TableWrapper>
    <div className="order">
      <div className="order__header">
        <OrderDetailedHeader
          onClose={onClose}
          inn={inn}
          id={refId}
          title={name}
          date={date}
          time={time}
          status={getOrderStatusBadge(status)}
        />
      </div>
      <div className="order__body order__body--empty-page">
        <NoticeBig
          link=""
          icon={ErpIcon}
          bottom={
            <IconBtn onClick={onClose} title="Закрыть и перейти в реестр" />
          }
          title="Новый заказ, по данному заказу отгрузки еще не проводились"
          text="Как только в ERP-системе появится информация об отгрузках, заказы обновятся и будут доступны для работы."
        />
      </div>
      <TableFooterWrapper blank />
    </div>
  </TableWrapper>
);

export default OrderDetailedEmpty;
